import { getStateMeta } from "./StateMeta";
export function StateDefine(schema) {
  return function (target, prop) {
    const meta = getStateMeta(target.constructor);
    meta.setStateSchema(prop, schema);
  };
}
//# sourceMappingURL=StateDefine.js.map
